<template>
  <div :id="id" :class="['tabs', `tabs--${tabsType}`, tabsClass]">
    <template v-for="(tab, i) in tabs">
      <input
        :id="label(i)"
        :key="`input-${i}`"
        class="visually-hidden"
        type="radio"
        :name="`tabs-${id}`"
        :checked="current === i"
        @change="handleTab(i)"
      />
      <label :key="`label-${i}`" :for="label(i)" ref="tab">
        <template v-if="tab.labelShort">
          <span v-if="mediaSmMatches" v-html="tab.labelShort" />
          <span v-else v-html="tab.label" />
        </template>
        <template v-else>
          <span v-html="tab.label" />
        </template>
      </label>
    </template>
    <span ref="caret" class="caret" />
  </div>
</template>

<script>
import { nanoid } from 'nanoid';
import { BREAKPOINTS } from '~scripts/core/breakpoints';
import 'styles/components/vue/_tabs.scss';

export default {
  name: 'VTabs',
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    tabsType: {
      type: String,
      default: 'default',
    },
    tabsClass: {
      type: String,
      default: '',
    },
    currentTab: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      id: nanoid(),
      current: this.currentTab,
      mediaSmMatches: false,
    };
  },
  computed: {
    mediaSm() {
      return window.matchMedia(`(max-width: ${BREAKPOINTS.smMax})`);
    },
  },
  mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });

    this.handleMediaSmMatchesChange();
    this.mediaSm.addEventListener('change', this.handleMediaSmMatchesChange, { passive: true });

    this.handleCaret(this.currentTabEl());
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);

    this.mediaSm.removeEventListener('change', this.handleMediaSmMatchesChange);
  },
  methods: {
    onResize() {
      this.handleCaret(this.currentTabEl());
    },
    handleMediaSmMatchesChange() {
      this.mediaSmMatches = this.mediaSm.matches;
    },
    currentTabEl() {
      return this.$refs.tab[this.current];
    },
    handleTab(index) {
      this.current = index;
      this.$emit('tab', index, this.id);

      this.handleCaret(this.currentTabEl());
    },
    handleCaret(tab) {
      const caret = this.$refs.caret;

      setTimeout(() => {
        caret.style.transform = `translateX(${tab.offsetLeft}px)`;
        caret.style.width = `${tab.offsetWidth}px`;
      }, 0);
    },
    label(index) {
      return `option-${this.id}-${index}`;
    },
  },
};
</script>

<style></style>
